import {ApiException, PermissionDenied, RecordNotFound, ValidationError} from "@/domain/core/exception/exceptions"

export default class ApiClient {

    constructor(axios) {
        this.axios = axios
    }

    async get(url, params) {
        try {
            const response = await this.axios.get(url, {params: params})
            return response.data
        } catch (error) {
            this.throw_exception(error)
        }
    }

    async post(url, params) {
        try {
            const response = await this.axios.post(url, params)
            return response.data
        } catch (error) {
            this.throw_exception(error)
        }
    }

    async patch(url, params) {
        try {
            const response = await this.axios.patch(url, params)
            return response.data
        } catch (error) {
            this.throw_exception(error)
        }
    }

    async delete(url, params) {
        try {
            const response = await this.axios.delete(url, params)
            return response.data
        } catch (error) {
            this.throw_exception(error)
        }
    }

    async put(url, params) {
        try {
            const response = await this.axios.put(url, params)
            return response.data
        } catch (error) {
            this.throw_exception(error)
        }
    }

    async upload(url, form, onProgress) {
        try {
            const response = await this.axios.post(url, form, {
                headers: {'Content-Type': 'multipart/form-data'},
                onUploadProgress: (progressEvent) => {
                    onProgress({
                        loaded: progressEvent.loaded,
                        total: progressEvent.total
                    })
                }
            })
            return response.data
        } catch (error) {
            this.throw_exception(error)
        }
    }

    throw_exception(error) {
        if (error.response) {
            if (error.response.status === 404)
                throw new RecordNotFound(error.response.config.url, error.response.status, error.response.data)
            if (error.response.status === 403)
                throw new PermissionDenied(error.response.config.url, error.response.status, error.response.data)
            if (error.response.status === 400)
                throw new ValidationError(error.response.config.url, error.response.status, error.response.data)
        }
        throw new ApiException(error.response.config.url, error.response.status, error.response.data)
    }
}
